import { createSlice } from '@reduxjs/toolkit';

import { apiHostname } from 'shared/constants';
import { AlphamartHttpError } from 'shared/types';
import {
  GenericStoreReducer,
  GenericStoreSlice,
  GenericThunk,
  getGenericReducers,
} from './shared/createGenericStoreSlice';

const invitationResendSlice = createSlice<
  GenericStoreSlice,
  GenericStoreReducer<GenericStoreSlice>
>({
  name: 'invitationResend',
  initialState: { error: undefined, isPending: false },
  reducers: {
    ...getGenericReducers(),
  },
});

export const { success, failure, pending: submitting } = invitationResendSlice.actions;

export default invitationResendSlice.reducer;

export const invitationResend =
  (id: number): GenericThunk =>
  async (dispatch, getState, httpClient) => {
    try {
      dispatch(submitting());
      await httpClient.post(`${apiHostname}/api/users/${id}/invitation`);
      dispatch(success({}));
    } catch (err) {
      dispatch(failure((err as AlphamartHttpError)?.response?.data?.message));
      return Promise.reject((err as AlphamartHttpError)?.response?.data ?? err);
    }
  };
